import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// CreateAppPage redirects to app-summary (describe-your-app flow)
export default function CreateAppPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/app-summary', { replace: true });
  }, [navigate]);
  
  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-zapt-purple mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
